export function getDragCursor(canDrag: boolean, isDragging: boolean): string {
  if (!canDrag) {
    return 'default';
  }

  return isDragging ? 'grabbing' : 'grab';
}
